import { useState, useEffect } from "react";
const useSiteNewModal = () => {
  const [showSiteNewModal, setShowSiteNewModal] = useState<boolean>(false);
  const [serviceBillUid, setServiceBillUid] = useState<string>("");

  const openSiteNewModal = () => {
    setShowSiteNewModal(true);
  };
  const hideSiteNewModal = () => {
    setShowSiteNewModal(false);
  };

  return {
    showSiteNewModal,
    setShowSiteNewModal,
    serviceBillUid,
    setServiceBillUid,
    openSiteNewModal,
    hideSiteNewModal,
  };
};

export default useSiteNewModal;
